// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
/** The `seal-at-close` value of `EBallotBoxSealPolicy`, without importing ui-core. */
var SEAL_AT_CLOSE = "seal-at-close";
/**
 * Whether an election event seals its ballot boxes at close, from its
 * presentation (an object, or its JSON text). Any other or no value means it
 * doesn't, and the portal then reads no seals at all.
 */
export var isSealAtClose = function (presentation) {
    var value = presentation;
    if (typeof value === "string") {
        try {
            value = JSON.parse(value);
        }
        catch (_a) {
            return false;
        }
    }
    return (!!value &&
        typeof value === "object" &&
        value.ballot_box_seal_policy === SEAL_AT_CLOSE);
};
/**
 * The effective Seal Record Publication policy of an event presentation:
 * `public` only when set to it, else `restricted` (the default), as the
 * server and the database lock read it.
 */
export var effectiveSealRecordPolicy = function (presentation) {
    return !!presentation &&
        typeof presentation === "object" &&
        presentation.ballot_box_seal_record_policy ===
            "public"
        ? "public"
        : "restricted";
};
